import { render, staticRenderFns } from "./JSONataErrorExplainer.vue?vue&type=template&id=6aa7311f&"
import script from "./JSONataErrorExplainer.vue?vue&type=script&lang=js&"
export * from "./JSONataErrorExplainer.vue?vue&type=script&lang=js&"
import style0 from "./JSONataErrorExplainer.vue?vue&type=style&index=0&id=6aa7311f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports